import { takeLatest, call, put, select } from 'redux-saga/effects';
import { selectSizeBasedOnDeviceType } from 'yoda-site-components/lib/selectors/ContextSelector';
import { getCustomOptions } from 'yoda-interfaces/lib/Pdp/CustomOptionsApi';
import {
    CUSTOM_OPTIONS_GET_SUCCESS,
    CUSTOM_OPTIONS_GET_ERROR,
    CUSTOM_OPTIONS_GET_REQUEST,
} from '../actionTypes/CustomOptionsActionTypes';

function* CustomOptionsSaga(url) {
    try {
        const payload = {
            deviceSize: yield select(selectSizeBasedOnDeviceType),
            url: url.payload,
        };
        const customOptions = yield call(getCustomOptions, payload);
        yield put({ type: CUSTOM_OPTIONS_GET_SUCCESS, payload: customOptions });
    } catch (error) {
        yield put({ type: CUSTOM_OPTIONS_GET_ERROR, error });
    }
}

const watchCustomOptionsSaga = function* watchCustomOptionsSaga() {
    yield takeLatest(CUSTOM_OPTIONS_GET_REQUEST, CustomOptionsSaga);
};

watchCustomOptionsSaga.sagaName = 'customOptionsSaga';

export default watchCustomOptionsSaga;
